// extracted by mini-css-extract-plugin
export default {"boxes":"Dashboard_boxes__yEsLZ","main":"Dashboard_main__1LGNs","lowerSection":"Dashboard_lowerSection__rS7eh","seedBtn":"Dashboard_seedBtn__HDqob"};